import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {MachineModelPersistRequest} from "../model/requests/machine-model-persist-request";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class MachineModelsService {

  private readonly modelURL: string;


  constructor(private http: HttpClient) {
    this.modelURL = '/api/models';
  }

  public getModels(): Observable<any> {
    return this.http.get<any>(this.modelURL);
  }

  public getModelsSummary(): Observable<any> {
    return this.http.get<any>(this.modelURL + "/summary");
  }

  public getModel(uuid: string): Observable<any> {
    return this.http.get<any>(this.modelURL + "/" + uuid);
  }

  public newModel(machineModelData: MachineModelPersistRequest): Observable<any> {
    return this.http.post<any>(this.modelURL, machineModelData);
  }

  public updateModel(machineModelData: MachineModelPersistRequest): Observable<any> {
    return this.http.put<any>(this.modelURL + "/" + machineModelData.machineModelUuid, machineModelData);
  }

  public deleteModel(uuid: string): Observable<any> {
    return this.http.delete<any>(this.modelURL + "/" + uuid);
  }

}
